import axios from "axios";
const apiService = require("./services");

export default {
  // Ottieni le località nel raggio
  async getLocalitaNelRaggio(coordinates, radiusKm, minPopulation) {
    try {
      // **Validazione input**
      if (
        !Array.isArray(coordinates) ||
        coordinates.length !== 2 ||
        isNaN(coordinates[0]) ||
        isNaN(coordinates[1])
      ) {
        throw new Error(
          "Il parametro 'coordinates' deve essere un array con [latitudine, longitudine]."
        );
      }

      if (!radiusKm || isNaN(radiusKm) || radiusKm <= 0) {
        throw new Error(
          "Il parametro 'radiusKm' deve essere un numero positivo."
        );
      }

      if (
        minPopulation !== undefined &&
        (isNaN(minPopulation) || minPopulation < 0)
      ) {
        throw new Error(
          "Il parametro 'minPopulation' deve essere un numero positivo o nullo."
        );
      }

      // **Chiamata al service**
      const localita = await apiService.fetchLocalitaNelRaggio(
        coordinates,
        radiusKm,
        minPopulation
      );
      // Filtra le località in base alla popolazione minima, se specificata
      const filteredLocalita = minPopulation
        ? localita.filter((loc) => loc.popolazione >= minPopulation)
        : localita;

      return filteredLocalita;
    } catch (error) {
      console.error("Errore nella richiesta per ottenere le località:", error);
      throw error;
    }
  },

  // Geocodifica un indirizzo per ottenere le coordinate
  async geocodeAddress(address) {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
      address
    )}`;
    try {
      const response = await axios.get(url);

      if (response.data.length > 0) {
        const lat = parseFloat(response.data[0].lat);
        const lon = parseFloat(response.data[0].lon);

        if (isNaN(lat) || isNaN(lon)) {
          throw new Error("Coordinate non valide");
        }

        return [lat, lon];
      } else {
        throw new Error("Indirizzo non trovato");
      }
    } catch (error) {
      throw new Error(
        "Errore nella geocodifica dell'indirizzo. Riprova più tardi."
      );
    }
  },

  // Metodo per aggiornare la mappa
  async searchAziendaLocalita(
    comuneAzienda,
    provinciaAzienda,
    radiusAzienda,
    minPopulation
  ) {
    try {
      // Validazione dei parametri
      if (!comuneAzienda || !provinciaAzienda) {
        throw new Error(
          "Dati incompleti: specificare comune, provincia e raggio."
        );
      }

      if (isNaN(radiusAzienda) || radiusAzienda <= 0) {
        throw new Error("Il raggio deve essere un numero positivo.");
      }

      if (
        minPopulation !== undefined &&
        (isNaN(minPopulation) || minPopulation < 0)
      ) {
        throw new Error(
          "La popolazione minima deve essere un numero positivo."
        );
      }

      // Geocodifica l'indirizzo
      const indirizzoCompleto = `${comuneAzienda}, ${provinciaAzienda}`;
      const coordinates = await this.geocodeAddress(indirizzoCompleto);
      if (!coordinates) {
        throw new Error("Indirizzo non trovato o coordinate mancanti.");
      }

      // Ottieni le località nel raggio
      const localita = await this.getLocalitaNelRaggio(
        coordinates,
        radiusAzienda,
        minPopulation
      );

      // Ritorna i dati elaborati
      return {
        azienda: {
          comune: comuneAzienda,
          provincia: provinciaAzienda,
          coordinates,
        },
        localita,
      };
    } catch (error) {
      console.error("Errore durante la ricerca delle località:", error.message);
      throw new Error(
        error.message || "Errore durante la ricerca delle località."
      );
    }
  },

  //ricerca degli ateco
  async loadAtecoList(authStore) {
    try {
      const response = await apiService.loadAtecoList(authStore);

      response.forEach((item) => {
        item.DESCRIZIONE = `${item.CODICE} - ${item.DESCRIZIONE}`;
      });

      // Ritorna la lista degli ATECO
      return response;
    } catch (error) {
      throw new Error(
        "Errore durante il caricamento della lista degli ATECO: " +
          error.message
      );
    }
  },

  //ricerca degli ateco
  async searchAzienda(authStore, selectedAtecoCodes, provincia) {
    const response = await apiService.searchAzienda(
      authStore,
      selectedAtecoCodes,
      provincia
    );

    return response;
  },

  async generateExcel(
    aziendaData,
    localitaData,
    localitaSelezionateData,
    aziendeTrovateData
  ) {
    const response = await apiService.generateExcel(
      aziendaData,
      localitaData,
      localitaSelezionateData,
      aziendeTrovateData
    );

    return response;
  },
};
